// extracted by mini-css-extract-plugin
module.exports = {"chartPlaceHolder":"Parking_chartPlaceHolder__2ppcO","chartLegend":"Parking_chartLegend__2ugCB"};